import { render, staticRenderFns } from "./sale_goal_setter.vue?vue&type=template&id=0a2ce235&scoped=true&"
import script from "./sale_goal_setter.vue?vue&type=script&lang=js&"
export * from "./sale_goal_setter.vue?vue&type=script&lang=js&"
import style0 from "./sale_goal_setter.vue?vue&type=style&index=0&id=0a2ce235&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2ce235",
  null
  
)

export default component.exports